// University of St. Thomas (Minnesota) undergraduate majors (#2748). Read on
// 2026-10-01 from the official undergraduate catalog's "Current Undergraduate
// Curricula" page (heading "2026-2027 Curricula"), whose program list is
// served from stthomas.edu/catalog/catalog-filter.json with each program's
// type (major, minor, certificate) and school. Every entry typed as a major
// is kept, under the school string the catalog gives it (two-school entries
// form their own group). Left out: "Business", "Engineering" and "Teacher
// Education", which the list types as majors but whose pages are overviews
// that point to the majors listed separately here. Added: Music Business
// (B.A.), a major the Music page lists ("Majors in Music Business (B.A.)")
// but the program list does not. Degrees come from each program page's
// "Major in ... (B.S.)" headings, the Business page's degree list (BSBA for
// the Opus majors it names, BA for Business Administration) and the
// Engineering page (BSCE, BSCPE, BSEE, BSME); where a page names no degree
// it is null. The Mathematics page writes "B.A" without the final period;
// it is written "B.A." here. The KB's majors list was the starting point;
// the catalog wins.
const majors = {
    "slug": "university-of-st-thomas-minnesota",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in the University of St. Thomas's official 2026-2027 undergraduate catalog, grouped by the college or school that offers it, with the degree where the catalog names one. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "B.S."
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Biology of Global Health",
                    "degree": null
                },
                {
                    "name": "Catholic Studies",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Classics",
                    "degree": null
                },
                {
                    "name": "Communication Studies",
                    "degree": null
                },
                {
                    "name": "Computer Sciences",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": null
                },
                {
                    "name": "Data Analytics",
                    "degree": "B.S."
                },
                {
                    "name": "Data Science",
                    "degree": "B.S."
                },
                {
                    "name": "Digital Media Arts",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Family Studies",
                    "degree": null
                },
                {
                    "name": "Film Studies",
                    "degree": null
                },
                {
                    "name": "Film Studies and Media Production",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Geology",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Justice and Peace Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Modern and Classical Languages",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": "B.M., B.A."
                },
                {
                    "name": "Music Business",
                    "degree": "B.A."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Strategic Communication: Advertising and Public Relations",
                    "degree": null
                },
                {
                    "name": "Theology",
                    "degree": null
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "Opus College of Business",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Administration",
                    "degree": "BA"
                },
                {
                    "name": "Business Communication",
                    "degree": "BSBA"
                },
                {
                    "name": "Entrepreneurship",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "BSBA"
                },
                {
                    "name": "International Business",
                    "degree": "BSBA"
                },
                {
                    "name": "Law and Compliance",
                    "degree": "BSBA"
                },
                {
                    "name": "Leadership and Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Marketing Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Operations and Supply Chain Management",
                    "degree": "BSBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BSBA"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSCPE"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSEE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Morrison Family College of Health",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Exercise Science",
                    "degree": null
                },
                {
                    "name": "Health Promotion & Wellness",
                    "degree": null
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Social Work",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "School of Education",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Elementary Education",
                    "degree": null
                },
                {
                    "name": "Special Education",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "College of Arts and Sciences and School of Education",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Chemistry (9-12)",
                    "degree": null
                },
                {
                    "name": "Communication Arts & Literature (5-12)",
                    "degree": null
                },
                {
                    "name": "Instrumental Music Education (K-12)",
                    "degree": null
                },
                {
                    "name": "Life Science (9-12)",
                    "degree": null
                },
                {
                    "name": "Mathematics 5-12",
                    "degree": null
                },
                {
                    "name": "Physics (9-12)",
                    "degree": null
                },
                {
                    "name": "Social Studies (5-12)",
                    "degree": null
                },
                {
                    "name": "Vocal Music Education (K-12)",
                    "degree": null
                },
                {
                    "name": "World Language and Cultures Education (K-12)",
                    "degree": null
                }
            ],
            "note": "The catalog lists these programs under both schools."
        },
        {
            "name": "College of Arts and Sciences and Morrison Family College of Health",
            "source": {
                "label": "St. Thomas 2026-2027 Undergraduate Catalog, Current Undergraduate Curricula",
                "url": "https://www.stthomas.edu/catalog/curricula/"
            },
            "majors": [
                {
                    "name": "Social Work and Criminal Justice",
                    "degree": null
                },
                {
                    "name": "Social Work and Psychology",
                    "degree": null
                },
                {
                    "name": "Social Work and Sociology",
                    "degree": null
                }
            ],
            "note": "The catalog lists these programs under both schools."
        }
    ]
};

export default majors;
